export function getOrderStateClass(state) {
  const classes = {
    'pending': 'bg-yellow-100 text-yellow-800',
    'in_progress': 'bg-blue-100 text-blue-800',
    'finish': 'bg-green-100 text-green-800',
    'cancel': 'bg-red-100 text-red-800',
    'return': 'bg-orange-100 text-orange-800'
  };

  return classes[state] || 'bg-gray-100 text-gray-800';
}

export function getOrderStateLabel(state) {
  const labels = {
    'pending': 'Pendiente',
    'in_progress': 'En Proceso',
    'finish': 'Finalizada',
    'cancel': 'Cancelada',
    'return': 'Devolución'
  };

  return labels[state] || 'Desconocido';
} 